












































































import { Component, Vue, Emit } from 'vue-property-decorator';
import { dedicatedMachineDetailsService } from '@/components/dedicated-machine-edit/services/DedicatedMachineDetailsService';
import { mapState } from 'vuex';

@Component({
  props: ['dedicatedMachine', 'orginalDescription'],
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class DedicatedMachineActions extends Vue {
  workspaceId = 0;
  regionId = 0;
  dedicatedMachineId = 0;
  isEditingDescriptionHidden = true;
  isRemoveModalShown = false;
  errors: any = [];
  isLoading = false;

  @Emit()
  onStatusChange() {
    return;
  }
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.dedicatedMachineId = parseInt(this.$route.params.dedicatedMachineId, 10);
  }
  onCloseRemoveModal() {
    this.isRemoveModalShown = false;
  }
  openRemoveModal() {
    if (this.$props.dedicatedMachine.state === 'busy') {
      return;
    }
    this.isRemoveModalShown = true;
  }
  editDedicatedMachineDescription() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    dedicatedMachineDetailsService
      .editDedicatedMachineDetails(this.workspaceId, this.regionId, this.dedicatedMachineId, {
        name: this.$props.dedicatedMachine.name,
        description: this.$props.dedicatedMachine.description,
      })
      .then(() => {
        this.isLoading = false;
        this.isEditingDescriptionHidden = true;
        this.$props.orginalDescription = this.$props.dedicatedMachine.description;
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  cancelDescription() {
    this.isEditingDescriptionHidden = !this.isEditingDescriptionHidden;
    this.$props.dedicatedMachine.description = this.$props.orginalDescription;
  }
  powerOnOff() {
    if (this.$props.dedicatedMachine.state === 'busy' || this.$props.dedicatedMachine.state === 'error') {
      return;
    }
    if (this.$props.dedicatedMachine.state === 'on' || this.$props.dedicatedMachine.state === 'idle') {
      this.powerOff();
    } else {
      this.powerOn();
    }
  }
  powerOff() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    dedicatedMachineDetailsService
      .powerOffDedicatedMachine(this.workspaceId, this.regionId, this.dedicatedMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  deleteDedicatedMachine() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    dedicatedMachineDetailsService
      .deleteDedicatedMachine(this.workspaceId, this.regionId, this.dedicatedMachineId)
      .then(() => {
        this.isLoading = false;
        this.$router
          .push(`/workspaces/${this.workspaceId}/regions/${this.regionId}/dedicated-machines-list`)
          .catch(() => {});
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  powerOn() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    dedicatedMachineDetailsService
      .powerOnDedicatedMachine(this.workspaceId, this.regionId, this.dedicatedMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  restart() {
    if (
      this.$props.dedicatedMachine.state === 'busy' ||
      this.$props.dedicatedMachine.state === 'error' ||
      this.$props.dedicatedMachine.state === 'off'
    ) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    dedicatedMachineDetailsService
      .restartDedicatedMachine(this.workspaceId, this.regionId, this.dedicatedMachineId)
      .then(() => {
        this.isLoading = false;
        this.onStatusChange();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
